import { LimitsReviewResponse } from '../../../models/limits/limits.model';
import { useGet, useSend } from '../../useApi';

// GET /admin/limits/review and POST /admin/limits/review/run (D32).
const useLimitsReview = () => {
  const { data, loading, fetch, setData } = useGet<LimitsReviewResponse>('Failed to load the limits review');
  const { loading: running, send } = useSend<LimitsReviewResponse>('Could not build the review');
  return {
    review: data,
    loading,
    running,
    fetchReview: (month?: string) => fetch('api/v1/admin/limits/review', month ? { month } : undefined),
    runReview: (month?: string, onDone?: () => void) =>
      send({ url: 'api/v1/admin/limits/review/run', method: 'post', params: month ? { month } : undefined }, (body) => {
        setData(body);
        onDone?.();
      }),
  };
};

export default useLimitsReview;
